// Section 4 phase 1 (Report): opens the season's report with a start-of-season snapshot.
// Last season's report is already in history; this phase starts the next one.
import { emptySeasonReport } from '../core/state-init';
import type { Phase } from '../core/types';

export const reportPhase: Phase = {
  id: 'report',
  reads: ['people', 'stocks', 'turn', 'year', 'season'],
  writes: ['currentReport'],
  projection: 'run',
  run(ctx) {
    // Read the committed state (nothing is written before this), not the draft (Section 2).
    ctx.draft.currentReport = emptySeasonReport(ctx.state);
    return 'done';
  },
};
